import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { ToastContainer } from 'react-toastify';
import {errorMesg} from './../../Pages/Toaster';

import {saveProfileAPI, getProfileDataAPI} from "./../../API/Publisher/ProfileAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";


const Profile = () =>{

    //const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [contact, setContact] = useState("");
    const [username, setUsername] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [pincode, setPincode] = useState("");
    const [image, setImage] = useState(null);
    const [previewimage, setPreviewImage] = useState(null);
    const [btnloader, setBtnLoader] = useState(false);

    useEffect(() => {

        getProfileDataAPI(setName, setEmail, setContact, setUsername, setAddress, setCity, setState, setPincode, setImage);

    }, []);

    const handleSetName = (e) =>{
        setName(e.target.value);
    }

    const handleSetEmail = (e) =>{
        setEmail(e.target.value);
    }

    const handleSetContact = (e) =>{
        setContact(e.target.value);
    }

    /*const handleSetUsername = (e) =>{
        setUsername(e.target.value);
    }*/

    const handleSetAddress = (e) =>{
        setAddress(e.target.value);
    }

    const handleSetCity = (e) =>{
        setCity(e.target.value);
    }

    const handleSetState = (e) =>{
        setState(e.target.value);
    }

    const handleSetPincode = (e) =>{
        setPincode(e.target.value);
    }

    const handleUploadImage = (e) =>{
        const imagefile = e.target.files[0];

        console.log('image file===='+imagefile);

        if(!imagefile)
            return;

        /*if(!imagefile.type.startWith("image/"))
        {
            errorMesg("Upload only image file");
            return;
        }*/

        setImage(imagefile);

        const imagereader = new FileReader();
        
        imagereader.onloadend = () => { 
            
            setPreviewImage(imagereader.result);

            document.getElementById("removeImage1").classList.add("profile-remove-btn");
            document.getElementById("ImgPreview").classList.add("it");
            //console.log('image reader=====' + imagereader.result);
        }
        imagereader.readAsDataURL(imagefile);

    }

    const handleRemoveImagePreview = (e) =>{
        e.preventDefault();

        const imgselector = document.getElementById("ImgPreview");
        
        imgselector.setAttribute("src", "");
        imgselector.classList.remove("it");
        document.getElementById("removeImage1").classList.remove("profile-remove-btn");
        setImage("");
    }

    const handleSaveProfile = (e) =>{
        e.preventDefault();

        if(name === "")
        {
            errorMesg("Please enter your name");
            return;
        }
        else if(email === "")
        {
            errorMesg("Please enter your email");
            return;
        }
        else if(contact === "")
        {
            errorMesg("Please enter your contact");
            return;
        }
        
        const formdata = new FormData();
        formdata.append('name', name);
        formdata.append('email', email);
        formdata.append('contact', contact);
        formdata.append('address', address);
        formdata.append('state', state);
        formdata.append('city', city);
        formdata.append('pincode', pincode);
        formdata.append('profileimg', image);

        saveProfileAPI(formdata, setBtnLoader);
    }

    const handleFormReset = (e) =>{
        e.preventDefault();

    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Profile</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="mb-3">
                                    <div class="profile-upload">
                                        <div class="profile-upload-img">
                                            <span><i class="ti ti-photo"></i></span>
                                            <img id="ImgPreview" src={previewimage} alt="img" class="preview1" />
                                            <button type="button" id="removeImage1" class="profile-remove" onClick={handleRemoveImagePreview}>
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </div>
                                        <div class="profile-upload-content">
                                            <label class="profile-upload-btn">
                                                <i class="ti ti-file-broken"></i> Upload File
                                                <input type="file" id="imag" class="input-img" onChange={handleUploadImage} accept="image/*" />
                                            </label>
                                            <p>JPG, GIF or PNG. Profile image size should be 300 X 300.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="border-bottom mb-3">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="mb-3">
                                                <label class="form-label">
                                                    Name <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" class="form-control" name="name" autocomplete="off" value={name} onChange={handleSetName} />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="mb-3">
                                                <label class="form-label">
                                                    User Name <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" class="form-control" name="username" autocomplete="off" defaultValue={username} readonly />
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-4">
                                            <div class="mb-3">
                                                <label class="form-label">
                                                    Phone Number <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" class="form-control" name="contact" autocomplete="off" value={contact} onChange={handleSetContact} />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="mb-3">
                                                <label class="form-label">
                                                    Email <span class="text-danger">*</span>
                                                </label>
                                                <input type="email" class="form-control" name="email" autocomplete="off" value={email} onChange={handleSetEmail} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="border-bottom mb-3 pb-3">
                                    <h5 class="fw-semibold mb-1">Address</h5>
                                    <p>Please enter the address details</p>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label">
                                                Address <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" class="form-control" name="address" autocomplete="off" value={address} onChange={handleSetAddress} />
                                        </div>
                                    </div>                                    
                                    <div class="col-lg-4 col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label">
                                                State / Province <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" class="form-control" name="state" autocomplete="off" value={state} onChange={handleSetState} />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label">
                                                City <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" class="form-control" name="city" autocomplete="off" value={city} onChange={handleSetCity} />
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label">
                                                Postal Code <span class="text-danger">*</span>
                                            </label>
                                            <input type="text" class="form-control" name="pincode" autocomplete="off" value={pincode} onChange={handleSetPincode}  />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-light me-2" onClick={handleFormReset}>Cancel</button>
                                    <button type="button" className="btn btn-primary"  onClick={handleSaveProfile}>
                                        {btnloader ?
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        :
                                            <p>Save Changes</p>
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <ToastContainer />
    </div>
    )
}

export default Profile;